import { render, staticRenderFns } from "./TabstyleNav.vue?vue&type=template&id=dc795f1a"
import script from "./TabstyleNav.vue?vue&type=script&lang=js"
export * from "./TabstyleNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports